/** Formats an ISO date string as a two-digit day/month/year using the browser's locale. */
export function formatDate(iso: string) {
  const d = new Date(iso)
  return d.toLocaleDateString(undefined, {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
  })
}
